import update from "immutability-helper";
import { SET_SCHEDULER_FILTERS } from "../constants/actionTypes";

const defaultState = {
  filters: {
    HSP: {},
    MDC: {},
  },
};

const scheduler = (state = defaultState, action) => {
  switch (action.type) {
    case SET_SCHEDULER_FILTERS:
      return update(state, {
        filters: {
          [action.section]: { $set: action.payload },
        },
      });
    default:
      return state;
  }
};

export default scheduler;
